import {
  SET_DOCUMENTOS_ANEXOS,
  SET_DOCUMENTOS_ANEXOS_ARRAY,
  LOADING_DOCUMENTOS_ANEXOS,
  LOADING_DOCUMENTOS_ANEXOS_ARRAY,
  ERROR_DOCUMENTOS_ANEXOS,
  ERROR_DOCUMENTOS_ANEXOS_ARRAY,
  HANDLE_CHANGE_DOCUMENTOS_ADMINISTRADOR_VALUE_FLAG,
  HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAFISICADEZMAIS_VALUE_FLAG,
  HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAFISICAMENOSDEZ_VALUE_FLAG,
  HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAJURIDICANACIONAL_VALUE_FLAG,
  HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAJURIDICAESTRANGEIRA_VALUE_FLAG,
  HANDLE_CHANGE_DOCUMENTOS_PROCURADOR_VALUE_FLAG,
  DELETE_DOCUMENTOS_ANEXO,
  DELETE_DOCUMENTOS_ARRAY_ANEXO,
  DELETE_GROUP_DOC,
  DELETE_GROUP_DOC_ARRAY,
  ADICIONAR_SOCIO_DEZOUMAIS,
  ADICIONAR_SOCIO_MENOSDEZ
} from './types';

const initialState = {
  idDocumentosAnexos: null,
  loadingIdDocumentosAnexos: false,
  errorIdDocumentosAnexos: null,

  documentosFileUploads: [],
  documentos_documentosAdministradorFlag: false,
  documentos_documentosSocioPessoaFisicaDezMaisFlag: false,
  documentos_documentosSocioPessoaFisicaMenosDezFlag: false,
  documentos_documentosSocioPessoaJuridicaNacionalFlag: false,
  documentos_documentosSocioPessoaJuridicaEstrangeiraFlag: false,
  documentos_documentosProcuradorFalg: false,
  listTypeArquivo: ["png", "jpeg", "pdf"],

  documentosSocioDezOuMais: [],
  idCountSocioDezOuMais: 0,
  documentosSocioMenosDez: [], 
  idCountSocioMenosDez: 0,
  documentos_documentoIdentificacaoFrente: {
    value: "",
    base64: "",
    fileType: null,
    IdDocumentoArquivo: '',
    asyncLoading: false,
    file: null,
    active: false,
    documents: []
  },
  documentos_documentoIdentificacaoVerso: {
    value: "",
    base64: "",
    fileType: null,
    IdDocumentoArquivo: '',
    asyncLoading: false,
    file: null,
    active: false,
    documents: []
  },
  documentos_comprovanteResidenciaComprovante: {
    value: "",
    base64: "",
    fileType: null,
    IdDocumentoArquivo: '',
    asyncLoading: false,
    file: null,
    active: false,
    documents: []
  },
  documentos_comprovanteRendaComprovante: {
    value: "",
    base64: "",
    fileType: null,
    IdDocumentoArquivo: '',
    asyncLoading: false,
    file: null,
    active: false,
    documents: []
  },
  documentos_contratoSocialComprovante: {
    value: "",
    base64: "",
    fileType: null,
    IdDocumentoArquivo: '',
    asyncLoading: false,
    file: null,
    active: false,
    documents: []
  },
  documentos_balancoPatrimonial: {
    value: "",
    base64: "",
    fileType: null,
    IdDocumentoArquivo: '',
    asyncLoading: false,
    file: null,
    active: false,
    documents: []
  },
  documentos_faturamentoUltimosMeses: {
    value: "",
    base64: "",
    fileType: null,
    IdDocumentoArquivo: '',
    asyncLoading: false,
    file: null,
    active: false,
    documents: []
  },
  documentos_procuracaoComprovante: {
    value: "",
    base64: "",
    fileType: null,
    IdDocumentoArquivo: '',
    asyncLoading: false,
    file: null,
    active: false,
    documents: []
  },
  documentos_estatutoPessoaJuridicaNacional: {
    value: "",
    base64: "",
    fileType: null,
    IdDocumentoArquivo: '',
    asyncLoading: false,
    file: null,
    active: false,
    documents: []
  },
  documentos_procuracaoPessoaJuridicaEstrangeira: {
    value: "",
    base64: "",
    fileType: null,
    IdDocumentoArquivo: '',
    asyncLoading: false,
    file: null,
    active: false,
    documents: []
  },
  documentos_IRPF: {
    value: "",
    base64: "",
    fileType: null,
    IdDocumentoArquivo: '',
    asyncLoading: false,
    file: null,
    active: false,
    documents: []
  }
}


export default function documentosAnexosReducer(state = initialState, action) {
  switch (action.type) {

    case HANDLE_CHANGE_DOCUMENTOS_ADMINISTRADOR_VALUE_FLAG:
      return {
        ...state,
        documentos_documentosAdministradorFlag: action.payload,
      }
    case HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAFISICADEZMAIS_VALUE_FLAG:
      {     
        let arraydocs = state.documentosSocioDezOuMais;
        let flag = action.payload.value;

        if (flag) {
          arraydocs = arraydocs.concat(
            {
              id: state.idCountSocioDezOuMais + 1,
              documentos_comprovanteRendaSocioPessoaFisicaDezOuMais: {
                value: "",
                base64: "",
                fileType: null,
                IdDocumentoArquivo: '',
                asyncLoading: false,
                file: null,
                active: false,
                documents: []
              }
            }
          )
        } else {
          if (state.documentosSocioDezOuMais.length > 1)
            flag = true;      
          
          arraydocs = state.documentosSocioDezOuMais.filter((x, index) => parseInt(x.id) !== parseInt(action.payload.idItem));
        }

        return {
          ...state,
          idCountSocioDezOuMais: state.idCountSocioDezOuMais + 1,
          documentos_documentosSocioPessoaFisicaDezMaisFlag: flag,
          documentosSocioDezOuMais: arraydocs
        }
      }      
    case HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAFISICAMENOSDEZ_VALUE_FLAG:
      {
        let arraydocs = state.documentosSocioMenosDez;
        let flag = action.payload.value;

        if (flag) {
          arraydocs = arraydocs.concat(
            {
              id: state.idCountSocioMenosDez + 1,
            }
          )
        } else {
          if (state.documentosSocioMenosDez.length > 1)
          flag = true;              
          arraydocs = state.documentosSocioMenosDez.filter((x, index) => parseInt(x.id) !== parseInt(action.payload.idItem));
        }

        return {
          ...state,
          idCountSocioMenosDez: state.idCountSocioMenosDez + 1,
          documentos_documentosSocioPessoaFisicaMenosDezFlag: flag,
          documentosSocioMenosDez: arraydocs
        }
      }
    case HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAJURIDICANACIONAL_VALUE_FLAG:
      return {
        ...state,
        documentos_documentosSocioPessoaJuridicaNacionalFlag: action.payload,
        documentos_estatutoPessoaJuridicaNacional: action.payload === false ? {
          value: "",
          base64: "",
          fileType: null,
          IdDocumentoArquivo: '',
          asyncLoading: false,
          file: null,
          active: false,
          documents: []
        } : state.documentos_estatutoPessoaJuridicaNacional,
      }

    case HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAJURIDICAESTRANGEIRA_VALUE_FLAG:
      return {
        ...state,
        documentos_documentosSocioPessoaJuridicaEstrangeiraFlag: action.payload,
        documentos_procuracaoPessoaJuridicaEstrangeira: action.payload === false ? {
          value: "",
          base64: "",
          fileType: null,
          IdDocumentoArquivo: '',
          asyncLoading: false,
          file: null,
          active: false,
          documents: []
        } : state.documentos_procuracaoPessoaJuridicaEstrangeira,
      }

    case HANDLE_CHANGE_DOCUMENTOS_PROCURADOR_VALUE_FLAG:
      return {
        ...state,
        documentos_documentosProcuradorFalg: action.payload,
        documentos_procuracaoComprovante: action.payload === false ? {
          value: "",
          base64: "",
          fileType: null,
          IdDocumentoArquivo: '',
          asyncLoading: false,
          file: null,
          active: false,
          documents: []
        } : state.documentos_procuracaoComprovante,
      }

    case SET_DOCUMENTOS_ANEXOS:
      {

        let { id } = action.payload;
        let newState = { ...state };
        newState[id] = { ...action.payload, documents: action.payload.documents.length === 0 && !action.payload.IdDocumentoArquivo ? action.payload.documents : newState[id].documents.concat([action.payload]) };

        // newState[id] =  action.payload;
        return newState;
      }
    case SET_DOCUMENTOS_ANEXOS_ARRAY:
      {
        let { id, nameDocs } = action.payload;
        let newState = {...state};

        newState[nameDocs].map((x, index) => {
          const nameDoc = id.split("#")[0];
          const idItem = id.split("#")[1];
          if (parseInt(x.id) === parseInt(idItem)) {
            x[nameDoc] = {
              ...action.payload,
              documents: action.payload.documents.length === 0 && !action.payload.IdDocumentoArquivo ? action.payload.documents : x[nameDoc].documents.concat([action.payload])
            }
          }
          return x;
        }); 

        return newState;
      }
    case LOADING_DOCUMENTOS_ANEXOS:
      {
        let { id, asyncLoading } = action.payload;
        let newState = { ...state };
        newState[id].asyncLoading = asyncLoading
        return newState;
      }
      case LOADING_DOCUMENTOS_ANEXOS_ARRAY:
        {
          let { id, asyncLoading, nameDocs } = action.payload;
          let newState = { ...state };
          
          newState[nameDocs].map((x, index) => {
            const nameDoc = id.split("#")[0];
            const idItem = id.split("#")[1];
            if (parseInt(x.id) === parseInt(idItem)) {
              x[nameDoc].asyncLoading = asyncLoading;
            }
            return x;
          }); 
          
          return newState;
        }
    case ERROR_DOCUMENTOS_ANEXOS:
      {
        let { id, errorMessage } = action.payload;
        let newState = { ...state };
        newState[id].errorMessage = errorMessage
        return newState;
      }
    case ERROR_DOCUMENTOS_ANEXOS_ARRAY:
      {
        let { id, errorMessage, nameDocs } = action.payload;
        let newState = { ...state };

        newState[nameDocs].map((x, index) => {
          const nameDoc = id.split("#")[0];
          const idItem = id.split("#")[1];
          if (parseInt(x.id) === parseInt(idItem)) {
            x[nameDoc].errorMessage = errorMessage;
          }
          return x;
        }); 

        return newState;
      }
    case DELETE_DOCUMENTOS_ANEXO:
      {
        let { id } = action.payload;
        let newState = { ...state };
        newState[id] = action.payload.documents.length === 0 ? {
          value: "",
          base64: "",
          fileType: null,
          IdDocumentoArquivo: '',
          asyncLoading: false,
          file: null,
          active: false,
          documents: []
        } : { ...action.payload };
        return newState;
      }
      case DELETE_DOCUMENTOS_ARRAY_ANEXO:
        {
          let { id, nameDocs } = action.payload;
          let newState = { ...state };

          newState[nameDocs].map((x, index) => {
            const nameDoc = id.split("#")[0];
            const idItem = id.split("#")[1];
            if (parseInt(x.id) === parseInt(idItem)) {
              if (x[nameDoc].documents.length <= 1) {
                x[nameDoc] = {
                  value: "",
                  base64: "",
                  fileType: null,
                  IdDocumentoArquivo: '',
                  asyncLoading: false,
                  file: null,
                  active: false,
                  documents: []
                }
              } else {
                x[nameDoc].documents = x[nameDoc].documents.filter(x => x.IdDocumentoArquivo !== action.payload.IdDocumentoArquivo);
              }
            }
            return x;
          });

          return newState;
        }
      case DELETE_GROUP_DOC:
        {
          let newState = { ...state };
          newState[action.payload.id] = {
            value: "",
            base64: "",
            fileType: null,
            IdDocumentoArquivo: '',
            asyncLoading: false,
            file: null,
            active: false,
            documents: []
          }

          return newState;
        }
      case DELETE_GROUP_DOC_ARRAY:
        {
          let newState = { ...state };
          let { id, nameDocs } = action.payload;

          newState[nameDocs].map((x, index) => {
            const nameDoc = id.split("#")[0];
            const idItem = id.split("#")[1];

            if (parseInt(x.id) === parseInt(idItem)) {
              x[nameDoc] = {
                value: "",
                base64: "",
                fileType: null,
                IdDocumentoArquivo: '',
                asyncLoading: false,
                file: null,
                active: false,
                documents: []
              }
            }
            return x;
          });
          
          return newState;
        }
      case ADICIONAR_SOCIO_DEZOUMAIS:
        return {
          ...state,
          idCountSocioDezOuMais: state.idCountSocioDezOuMais + 1,
          documentosSocioDezOuMais: 
          state.documentosSocioDezOuMais.concat(
            {
              id: state.idCountSocioDezOuMais + 1,
              documentos_comprovanteRendaSocioPessoaFisicaDezOuMais: {
                value: "",
                base64: "",
                fileType: null,
                IdDocumentoArquivo: '',
                asyncLoading: false,
                file: null,
                active: false,
                documents: []
              }
            }
          )
        }
      case ADICIONAR_SOCIO_MENOSDEZ:
          return {
            ...state,
            idCountSocioMenosDez: state.idCountSocioMenosDez + 1,
            documentosSocioMenosDez: 
            state.documentosSocioMenosDez.concat(
              {
                id: state.idCountSocioMenosDez + 1,
              }
            )
          }
    default:
      return state
  }
}